import _ from 'underscore';
import Backbone from 'backbone';
import config from 'config';
import io from 'socket-io';

var WebSocket = Backbone.Model.extend({

    defaults: {
        emitQueue: []
    },

    initialize: function() {
        _.bindAll(this, 'emitMessagesQueue');
        var socket = this.openSocket();
        this.set('socket', socket);
        this.listenTo(Backbone, 'socketEmit', this.emitMessage);
        this.listenTo(Backbone, 'socketOn', this.listenToMessage);
        this.listenTo(this.get('socket'), 'connect', this.emitMessagesQueue);
        this.listenTo(this.get('socket'), 'reconnect', this.emitMessagesQueue);
        this.listenTo(this.get('socket'), 'disconnect', this.emitMessagesQueue);
    },

    openSocket: function() {
        return io(config.realtimeUrl, {reconnection: config.shouldSocketIoReconnect});
    },

    emitMessage: function(message, data) {
        var socket = this.get('socket');
        if (socket.connected) {
            socket.emit(message, data);
        } else {
            var task = {};
            task.message = message;
            task.data = data;
            this.get('emitQueue').push(task);
        }
    },

    emitMessagesQueue: function() {
        var queue = this.get('emitQueue');
        var thisModel = this;
        _.each(queue, function(task) {
            thisModel.emitMessage(task.message, task.data);
        });

        this.set('emitQueue', []);
    },

    listenToMessage: function(message, callback) {
        var socket = this.get('socket');
        socket.on(message, callback);
    }
});

export default WebSocket;

